import {isEqual} from '@yandex-delivery/utils'
import {JAMS_PALETTE} from './consts'
import type {Jam, LoadRouteActionTypes, Point, RoutePoints, Props, RouteType, DrawingStyle} from './types'

export const isRoutePoints = (points: Point[]): points is RoutePoints => points.length >= 2

export const jamsToStyle = (jams: Jam[]): DrawingStyle => ({
  fillRule: 'nonzero',
  fill: '#333',
  fillOpacity: 0.9,
  stroke: [
    {
      width: 4,
      palette: jams.map(jam => ({color: JAMS_PALETTE[jam.type]?.color, count: jam.count})),
    },
    {
      width: 6,
      palette: jams.map(jam => ({
        color: JAMS_PALETTE[jam.type]?.border,
        count: jam.count,
      })),
    },
    {width: 10, color: '#fff'},
  ],
})

export const loadRoute = <TError,>(points: Point[], {onBoundsChange, onError}: LoadRouteActionTypes<TError>) =>
  new Promise<RouteType | null>((resolve, reject) => {
    const isRouteAvailable = isRoutePoints(points)
    const maps = window.yangomaps ? yangomaps : ymaps3
    if (isRouteAvailable && maps) {
      maps
        // TODO выпилить когда карты завезут свою реализацию CARGODEV-23652
        // @ts-expect-error маршруты находятся в разработке у карт, типов для них еще нет
        .route({type: 'driving', points, jams: true, bounds: true})
        .then((routes: {toRoute: () => RouteType}[]) => {
          const route = routes[0]?.toRoute?.()
          if (!route) {
            throw new Error('Route not found')
          }
          if (onBoundsChange) {
            onBoundsChange({bounds: route.properties.bounds, duration: 300})
          }
          resolve(route)
        })
        .catch(error => {
          onError?.(error)
          return reject(error)
        })
    } else {
      resolve(null)
    }
  })

export const arePropsEqual = (prevProps: Props, nextProps: Props) => {
  return (
    prevProps.drawJams === nextProps.drawJams &&
    prevProps.onBoundsChange === nextProps.onBoundsChange &&
    isEqual(prevProps.points, nextProps.points) &&
    prevProps.style === nextProps.style
  )
}
